import DialogComponent from "components/Dialog";

export default class ConfirmGigienDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            dialogFor: "general",
            step: 1,
            doctorId: false,
            comment: "",
            nextDate: null
        };
    }

    title = "directionType.cancel";

    show(info, hidCb) {
        this.dialogTitle = "Напоминание";
        this.dialogSaveLabel = "Назначаю";
        this.dialogCancelLabel = "Назначу точно позже!";
        this.state.info = info;
        this.hidCb = hidCb;

        super.show();
    }

    save() {
        const { step } = this.state;
        if (step === 1) {
            this.dialogSaveLabel = "Сохранить";
            this.changeState("step", 2);
        } else {
            const { doctorId, info, nextDate, comment, visitRulePeriodName } = this.state;
            const { clientId, domainId, overdueVisitId } = info;

            if (nextDate && doctorId) {

                const infoAdd = {
                    domainId,
                    targetDate: this._helper.date.toStr(nextDate),
                    clientId: clientId,
                    title: "Пригласить на гигиену",
                    comment: "",
                    remindBefore: null,
                    reasonId: 1,
                    doctorId: doctorId,
                    visitRule: {
                        visitRulePeriodName,
                        comment: comment
                    }
                };

                if (overdueVisitId)
                    infoAdd.id = overdueVisitId;

                this.hide();
                this.hidCb(infoAdd);
            }
        }
    }

    onDateChange(date) {
        this.changeState("nextDate", date);
    }

    onPeriodChange(periodId) {
        const { invitePeriod } = this._config;
        const date = new Date();
        const period = invitePeriod.find(it => it.id === periodId);

        let value = null;

        if (period.add.type === "day")
            value = this._helper.date.addDays(date, period.add.amount);
        else
            value = this._helper.date.addMonth(date, period.add.amount);

        this.selectDateCalendar.value = value;
        this.state.visitRulePeriodName = period.baseName;
        this.changeState("nextDate", value);
    }

    renderContent() {
        const { step, doctorId, comment, nextDate } = this.state;
        const { invitePeriod } = this._config;
        const period = invitePeriod.filter(it => it.attr.includes("invHygiene"));
        const items = period.filter(it => (it.id !== 1 && it.id !== 2 && it.id !== 3));

        return (
            <div className="content flex col gap16">
                {step === 1 ? <div className="text p1">Назначьте повторный визит на гигиену!</div> :
                    <div className="inviteDialog content flex col gap16 pos rel">
                        {this.insertSelectDoctor({
                            label: "client.seeDoctor",
                            value: doctorId,
                            onClick: this.changeState.bind(this, "doctorId")
                        })}
                        <div className="flex between gap8">
                            <div className="areaInput flex flex1 col gap8">
                                {this.insertSelect({
                                    showLeftIcon: false,
                                    label: "client.period",
                                    placeHolder: "main.notIndicated",
                                    translate: true,
                                    items: items,
                                    onChange: this.onPeriodChange.bind(this)
                                })}
                            </div>
                            <div className="flex1">
                                {this.insertSelectDate({
                                    ref: el => this.selectDateCalendar = el,
                                    onChange: this.onDateChange.bind(this),
                                    defaultValue: nextDate,
                                })}
                            </div>
                        </div>
                        <div>
                            {this.insertInput({
                                label: "client.note",
                                placeHolder: "client.note",
                                onChange: this.changeState.bind(this, "comment"),
                                value: comment
                            })}
                        </div>
                    </div>}
            </div>
        );
    }
}

